<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin"></i> Loading
  </div>
  <div class="animated fadeIn" v-else-if="form_data">
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <div class="py-3 px-3">
              <div v-if="attribute">
                <attributes-lists-card
                  :attribute="attribute"
                  :managed_list_options="managed_list_options"
                ></attributes-lists-card>
              </div>
              <template v-if="form_data_list.length">
                <template v-for="(form_data, index) in form_data_list">
                  <attributes-list-field-form-group
                    :key="index"
                    :form_data="form_data"
                    :managed_list_options="managed_list_options"
                    :form_data_list_length="form_data_list.length"
                    :parent_attributes_options="parentAttributesList"
                    @handleFormDataUpdate="handleFormDataUpdate"
                    @onRemoveAttribute="onRemoveAttribute"
                  ></attributes-list-field-form-group>
                </template>
              </template>
              <b-row v-if="!attribute">
                <b-col>
                  <b-button variant="success" @click="onAddAttribute" block
                    ><i class="fal fa-plus"></i
                  ></b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-3"
            variant="success"
          >
            <i class="fal fa-save"></i><span class="pl-2">Save</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import AttributeListCollection from "@/collections/lab/AttributeListCollection";
import AttributesListsCard from "./AttributesListsCard";
import AttributesListFieldFormGroup from "./AttributesListFieldFormGroup";
import ManagedListCollection from "@/collections/lab/ManagedListCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "AttributesListForm",
  components: {
    AttributesListsCard,
    AttributesListFieldFormGroup
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    attribute: {
      type: Object,
      default: () => null
    },
    managed_list_parent_id: {
      type: String,
      default: () => "f598cda4-6dac-497b-840b-b6718a0d20c0"
    }
  },
  computed: {
    ...mapGetters({ parent: "parentId" }),
    value: {
      get() {
        return this.form_data.value;
      },
      set(value) {
        this.form_data.value = value;
      }
    },
    parentAttributesList() {
      return (
        this.attributes_lists &&
        this.attributes_lists
          .filter(
            list =>
              list.managed_list_id === this.managed_list_parent_id
          )
          .map(option => {
            return {
              id: option.id,
              name: option.value
            };
          })
      );
    }
  },
  data() {
    return {
      attributes_lists_collection: new AttributeListCollection(),
      attributes_lists: null,
      loading: true,
      form_data_list: [],
      form_data: {
        id: this.$uuid.v4(),
        value: (this.attribute && this.attribute.value) || null,
        managed_list_id:
          (this.attribute && this.attribute.managed_list_id) || null,
        parent_id: (this.attribute && this.attribute.parent_id) || null
      },
      managed_lists_collection: new ManagedListCollection(),
      managed_list_options: null
    };
  },
  validations: {
    value: { required },
    form_data: {
      managed_list_id: { required }
    }
  },
  methods: {
    onAddAttribute() {
      this.form_data_list.push({ ...this.form_data, id: this.$uuid.v4() });
    },
    onRemoveAttribute(id) {
      this.form_data_list = this.form_data_list.filter(
        attribute => attribute.id !== id
      );
    },
    handleFormDataUpdate({ id, field, update }) {
      this.form_data_list = this.form_data_list.map(form_data => {
        if (form_data.id !== id) return form_data;
        switch (field) {
          case "value":
            return {
              ...form_data,
              value: update
            };
          case "managed_list_id":
            return {
              ...form_data,
              managed_list_id: (update && update.id) || null,
              parent_id: null
            };
          default:
            return {
              ...form_data,
              [field]: (update && update.id) || null
            };
        }
      });
    },
    submitForm() {
      this.$emit(
        "submit",
        this.attribute ? this.form_data_list[0] : this.form_data_list
      );
    },
    fetch() {
      const fetches = [];
      fetches.push(
        this.managed_lists_collection.fetch().then(({ response }) => {
          if (response && response.status === 200 && response.data) {
            this.managed_list_options = response.data.data.map(list => {
              return { id: list.id, name: list.description };
            });
          }
        })
      );
      fetches.push(
        this.attributes_lists_collection.fetch().then(({ response }) => {
          if (response && response.status === 200 && response.data) {
            this.attributes_lists = response.data.data;
          }
        })
      );
      return Promise.all(fetches);
    },
    async init() {
      await this.fetch();
    }
  },
  beforeMount() {
    if (this.parent) {
      this.form_data.managed_list_id = this.parent;
    }
    this.form_data_list = Array(1).fill(this.form_data);
  },
  mounted() {
    this.loading = true;
    this.init().then(() => {
      this.loading = false;
    });
  }
};
</script>
